import { render, staticRenderFns } from "./dealer_list.vue?vue&type=template&id=64b81c6b&scoped=true"
import script from "./dealer_list.vue?vue&type=script&lang=js"
export * from "./dealer_list.vue?vue&type=script&lang=js"
import style0 from "./dealer_list.vue?vue&type=style&index=0&id=64b81c6b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b81c6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b81c6b')) {
      api.createRecord('64b81c6b', component.options)
    } else {
      api.reload('64b81c6b', component.options)
    }
    module.hot.accept("./dealer_list.vue?vue&type=template&id=64b81c6b&scoped=true", function () {
      api.rerender('64b81c6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/add_user/dealer_list.vue"
export default component.exports